import { type AgentSubject } from "./AgentRecord";
import { AGENT_SUBJECT_KINDS, AGENT_SUBJECTS } from "./agentSubject";

/** The record an agent is launched on, which its launch page pre-fills. */
export interface LaunchSubject {
  /** Kind of record; picks the variable type and query parameter from ``AGENT_SUBJECTS``. */
  kind: AgentSubject;
  /** The record's id, filled into every variable of that type. */
  id: string;
}

/** The subject ids a launch link carries, by kind. */
export type LaunchSeed = Partial<Record<AgentSubject, string>>;

/** The seed as the launch page's search params; empty ids are left out. */
export function launchSeedToSearchParams(seed: LaunchSeed): URLSearchParams {
  const params = new URLSearchParams();
  for (const kind of AGENT_SUBJECT_KINDS) {
    const id = seed[kind];
    if (id) {
      params.set(AGENT_SUBJECTS[kind].queryParam, id);
    }
  }
  return params;
}

/** The seed the launch page's search params carry; empty values are left out. */
export function launchSeedFromSearchParams(
  params: URLSearchParams,
): LaunchSeed {
  const seed: LaunchSeed = {};
  for (const kind of AGENT_SUBJECT_KINDS) {
    const id = params.get(AGENT_SUBJECTS[kind].queryParam);
    if (id) {
      seed[kind] = id;
    }
  }
  return seed;
}
